import { render, staticRenderFns } from "./cModalMovementDetail.vue?vue&type=template&id=a68f4c3a"
import script from "./cModalMovementDetail.vue?vue&type=script&lang=js"
export * from "./cModalMovementDetail.vue?vue&type=script&lang=js"
import style0 from "./cModalMovementDetail.vue?vue&type=style&index=0&id=a68f4c3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports